import { z } from "zod";
import { schemes } from "../../schema-validation";

export const employeeBalanceSchema = z.object({
  employeeID: schemes.mongoObjectId(),
  balance: z.number().default(0),
  accrued: z.number().default(0),
});

export const employeeBalanceMapSchema = z.record(
  employeeBalanceSchema.omit({ employeeID: true })
);

export type EmployeeAccruedBalance = z.infer<typeof employeeBalanceMapSchema>;
